<template>
    <qrcode-vue :value="value" :size="size" level="H" />
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
    components: {
        QrcodeVue
    },
    props: {
        dataUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            value: this.dataUrl,
            size: 120
        };
    }
};
</script>
